import { ResponseContainer } from './DisplayContainer';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { formatClockTimeValue } from 'lib/utils/units';

const TimeDisplay = (props) => {
  const { i18n } = useTranslation();
  const { value } = props;

  return (
    <ResponseContainer>
      <SDiv>
        {formatClockTimeValue(value, i18n.language)}
      </SDiv>
    </ResponseContainer>
  );
};

export default TimeDisplay;

const SDiv = styled.div`
  && {
    margin: 0 5px;
  }
`;

const SLikertDiv = styled.div`
  && {
    margin: 5px;
  }
`;
